var React = require('react');

function Diff (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"id":"defs2","key":0}),React.createElement("g",{"id":"layer1","key":1},React.createElement("path",{"style":{"strokeWidth":"0.00708705"},"d":"M 3.175,1.8142876 H 2.2678575 V 2.7214303 H 1.3607142 v 0.907142 H 2.2678575 V 4.5357145 H 3.175 V 3.6285723 H 4.0821419 V 2.7214303 H 3.175 Z M 1.3607142,6.35 H 4.0821419 V 5.442858 H 1.3607142 Z M 4.5357145,0 H 0.90714303 V 0.45357254 H 4.3089277 l 1.5875,1.58749996 V 6.35 H 6.35 V 1.8142876 Z M 0,0.90714512 V 7.2571449 H 5.442858 V 2.2678575 L 4.0821419,0.90714512 Z M 4.9892855,6.8035752 H 0.45357116 V 1.360715 H 3.855358 l 1.1339275,1.1339301 z","id":"path833"}))]);
}

Diff.defaultProps = {"id":"svg8","version":"1.1","viewBox":"0 0 6.3499999 7.2571448","height":"7.2571449mm","width":"6.3499999mm"};

module.exports = Diff;

Diff.default = Diff;
